import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import CallContent from "./CallContent";
import Contact from "./Contact";
import GroupChat from "./GroupChat";
import PrivateChat from "./PrivateChat.tsx";

const ChatBoard = () => {
  const { messengerActiveTab } = useAppSelector((state) => state.messenger);

  return (
    <div className="chatzy-main small-sidebar">
      <div className={`chat-content tabto ${messengerActiveTab === "chat" ? "active" : ""}`}>
        <PrivateChat />
        <GroupChat />
      </div>
      <div className={`call-content tabto ${messengerActiveTab === "call" ? "active" : ""}`}>
        <CallContent />
      </div>
      <div className={`contact-content tabto ${messengerActiveTab === "contact" ? "active" : ""}`}>
        <Contact />
      </div>
    </div>
  );
};

export default ChatBoard;
